
import { createContext } from "react";
import { Outlet, useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { IProjectOverview } from "models/projects";
import ProjectsHeader from "./projects-header";
import useProjectOverview from "hooks/projects/useProjectOverview";
import { CustomCircularProgress } from "components/shared/layout";

const ProjectContext = createContext<IProjectOverview | null>(null);
const ProjectProvider = ProjectContext.Provider;
const ProjectConsumer = ProjectContext.Consumer;

const ProjectNotFound = () => (
    <Typography variant='subtitle1' color='error'>Project not found.</Typography>
)

const ProjectLayout = () => {
    const { projectId } = useParams();
    const [ project, loading, error ] = useProjectOverview(projectId);
    
    return (
        <Box>
            {loading ? <CustomCircularProgress /> :
                project ?
                    <ProjectProvider value={project}>
                        <ProjectsHeader
                            project={project}
                        />
                        <Outlet />
                    </ProjectProvider>
                    : <ProjectNotFound />
            }
        </Box>
    );
}

export default ProjectLayout;
export { ProjectContext, ProjectProvider, ProjectConsumer };